<template>
  <div class="main-container" :class="{ 'open-fade': isOpen }" style="overflow: auto;"  ref="modalContainer"
    @click="handleClickOutside($event)">
    <loading-component :value="loading"/>
    <div class="modal" :style="[this.$store.state.user.roles[0].name == 'Goverment' ? {'min-height': '550px','max-width': '90%'} : {'min-height': '50px','max-width': '90%',  'margin-bottom':' auto',
    'margin-top': 'auto'}]" :class="{ 'open-scale': isOpen }">
      <div class="close-button noselect" @click="cancel">
        <span>&#128473;</span>
      </div>
      <div v-if="complaint != null" style="display: flex; justify-content: space-between;">
        <div>
          <h2 style="display: flex; gap: 18px; justify-content: between;">
            <span>ID {{ complaint.id }} - {{ complaint.description }}</span>
            <span style="font-weight: normal;font-size: 18px;padding-top:1px ; padding-left: 22px; color: #788E98;">{{ $t("monitoring.complaintDialog.byDoer", { doer: complaint.doer }) }}</span>
          </h2>
        </div>
      </div>
      <p v-html="paragraph"></p>
      <div v-if="list.length > 0" class="list">
        <table>
          <tr>
            <td style="text-align: left; padding-bottom: 8px;" colspan="3">{{ $t("monitoring.complaintDialog.availableSoundFiles") }}</td>
          </tr>
          <tr>
            <td colspan="3">
              <hr>
            </td>
          </tr>
          <tbody v-for="(item, index) in list" :key="`${index}-file-${item.item}`">
            <tr>
              <td><b>{{ index + 1 }}</b></td>
              <td>{{ item.item }}</td>
              <td style="display: flex; flex-direction: row; gap: 12px; justify-content: flex-end;">
                <a v-if="!item.loading && !item.urlObject"
                  @click="!item.loading && downloadSound(item.item, index, true);" style="cursor: pointer;">{{ $t("monitoring.complaintDialog.playAudio") }}</a>
                <a v-if="!item.loading" @click="!item.loading && downloadSound(item.item, index);"
                  style="cursor: pointer;">{{ $t("common.download") }}</a>
                <label v-if="item.loading">{{ $t("common.loading") }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <audio style="width: 100%;" v-if="!item.loading && item.urlObject" controls>
                  <source :src="item.urlObject">
                </audio>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <hr>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div v-if="complaint != null && this.$store.state.user.roles[0].name == 'Goverment'" style="margin-top:2rem" >
      
          <h3>
            {{ $t("monitoring.complaintDialog.commentsSection") }}
          </h3>
          <textarea rows="4" cols="150" class="input" :type='text' :placeholder="$t('monitoring.complaintDialog.writeAComment')" style="padding:4px"
            v-model="commentText" />
          <div v-if="fileUpload">
            <!-- <label for="files">{{ fileUpload }}</label> -->
            <input class="input" type="file" name="files" @change="prepareFiles()" ref="files" multiple />
            <div class="buttons-container">
              <button @click="addComment">{{ $t("monitoring.complaintDialog.send") }}</button>
            </div>

          </div>
        <div  v-for="(item, index) in commentsList" style="margin-top:1rem;">
          <div style="display: flex; flex-direction: row; column-gap:1rem">
            <div>
              <span class="avatar-number">{{ item.doer[0].toUpperCase() }}</span>
            </div>
            <div style="width:100%">
              <div style="display:flex; flex-direction: row; column-gap: 1rem;">
                <p style="margin: 0; font-weight: 900;color:black">{{ item.doer }}</p>
                <p style="margin: 0;padding-top:4px ; font-size: smaller;"> {{ moment(item.created_at).format("HH[h]m - DD/MM/YYYY") }}</p>
              </div>
              <div>
                <div>
                  <p style="margin: 0;font-size: 700;color:rgb(14, 14, 14)">{{ item.comment }}</p>
                </div>
                <div v-if="item.audios.length > 0" class="list">
                  <table>
                    <tr>
                      <td style="text-align: left; padding-bottom: 4px;" colspan="3">{{ $t("monitoring.complaintDialog.commentSoundFiles") }}</td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <hr>
                      </td>
                    </tr>
                    <tbody v-for="(audio, index) in item.audios" :key="`${index}-file-${audio.item}`">
                      <tr>
                        <td><b>{{ index + 1 }}</b></td>
                        <td>{{ audio.item }}</td>
                        <td style="display: flex; flex-direction: row; gap: 12px; justify-content: flex-end;">
                          <a v-if="!audio.loading && !audio.urlObject"
                            @click="!audio.loading && downloadCommentSound(audio.item,item, index, true);"
                            style="cursor: pointer;">{{ $t("monitoring.complaintDialog.playAudio") }}</a>
                          <a v-if="!audio.loading" @click="!audio.loading && downloadCommentSound(audio.item,item, index);"
                            style="cursor: pointer;">{{ $t("common.download") }}</a>
                          <label v-if="audio.loading">{{ $t("common.loading") }}</label>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <audio style="width: 100%;" v-if="!audio.loading && audio.urlObject" controls>
                            <source :src="audio.urlObject">
                          </audio>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <hr>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>


        </div>
        
        </div>
      
      </div>
   
      <div>

       
      </div>
      <div class="buttons-container">
        <button @click="cancel" v-if="!hideCancel" outline>{{ $t("common.cancel") }}</button>
        <button @click="submit" :disabled="loading">
          <span :class="{ 'opacity-0': loading }">{{ $t("common.ok") }}</span>
          <div class="spring-spinner" v-if="loading">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import Select from "@/components/widgets/Select.vue";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "COMPLAINT_DIALOG_COMPONENT",

  components: {
    LoadingComponent,
    Select,
  },
  data() {
    return {
      isOpen: false,
      resolvePromise: null,
      rejectPromise: null,
      complaint: null,
      commentsList: [],
      paragraph: "",
      complaintStatus: null,
      type: "text",
      input: null,
      commentText: "",
      inputValue: "",
      loader: false,
      loading: false,
      files: [],
      type: "",
      list: [],
      hideCancel: false,
      inputs: [
        {
          placeholder: "",
          value: "",
          key: "",
        },
      ],
      additionalData: {},
      fileUpload: "",
      filesLoader: []
    };
  },
  methods: {
    addComment() {
      if (!this.commentText){
        window.getApp.$emit("SHOW_TOAST", this.$t("monitoring.complaintDialog.commentEmpty"), "red");
        return;
      }
      const params = new FormData();
      params.append("comment", this.commentText);
      if (this.files) {
        for (let i = 0; i < this.files.length; i++)
          params.append("wav_files[]", this.files[i]);
      }
      this.loading = true;
      axios
        .post(`complaint_comments/${this.complaint.id}/add_comment`, params)
        .then((res) => {
          this.loading = false;
          res.data.data.audios = res.data.data.audios.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
          this.commentsList.push(res.data.data);
          this.files = [];
          this.commentText= '';
          window.getApp.$emit("SHOW_TOAST", this.$t("monitoring.complaintDialog.commentAdded"));

        })
        .catch((err) => {
          console.log(err)
          console.log(err.response.data.message);
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },

    changeComplaintStatus(value) {
      this.loading = true;
      let status = value;
      axios.put(`complaint/${this.complaint.id}/update_status`, { status })
        .then(() => {
          this.loading = false;
          window.getApp.$emit("SHOW_TOAST", this.$t("monitoring.complaintDialog.saved"));

        })
    },
    handleClickOutside(event) {
      if (this.$refs.modalContainer == event.target) {
        this.cancel();
      }
    },
    openDialog(options) {
      return new Promise((resolve, reject) => {
        this.commentText = '';
        this.complaint = options.complaint;
        this.commentsList = options.complaint.comments;
        this.complaintStatus = options.complaint.status
        this.isOpen = true;
        this.text = options.title;
        this.paragraph = options.paragraph;
        this.inputs = null;
        this.input = null;
        if (!Array.isArray(options.input)) this.input = options.input || null;
        else this.inputs = options.input;
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
        this.loader = options.loader || false;
        this.loading = false;
        this.type = options.type || "";
        this.fileUpload = options.fileUpload || "";
        this.hideCancel = options.hideCancel || false;
        if (options.list) {
          this.list = options.list.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
        } else {
          this.list = [];
        }
        this.additionalData = options.additionalData || {};
      });
    },
    submit() {
      // let preparedInputs = null;
      // if (this.inputs) {
      //   preparedInputs = {};
      //   this.inputs.forEach((item) => {
      //     preparedInputs[item.key] = item.value;
      //   });
      // }
      // if (!this.loader) {
      //   this.resolvePromise({
      //     value: this.inputs ? preparedInputs : this.inputValue || null,
      //     files: this.files || null,
      //   });
         this.close();
      // } else {
      //   this.resolvePromise({
      //     close: this.close,
      //     value: this.inputs ? preparedInputs : this.inputValue || null,
      //     files: this.files || null,
      //   });
      //   this.loading = true;
      // }
    },
    close() {
      // if (this.list) {
      //   this.list.forEach((item) => {
      //     if (item.urlObject)
      //       URL.revokeObjectURL(item.urlObject)
      //   })
      // }
      // if (this.fileUpload) {
      //   this.$refs.files.value = null;
      // }
       this.loading = false;
       this.isOpen = false;
    },
    cancel() {
    //  this.rejectPromise();
      this.close();
    },
    downloadSound(name, index, showPlayer) {
      this.list[index].loading = true;
      axios({
        url: `complaint/${this.additionalData.id}/audio/${name}`,
        method: "GET",
        responseType: "blob",
      }).then((res) => {

        this.list[index].loading = false;
        const href = URL.createObjectURL(res.data);

        if (!showPlayer) {
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.innerHTML = " download";
          link.setAttribute("download", name); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } else {
          this.list[index].urlObject = href;
        }
      }).finally(() => {
        this.filesLoader[index] = false;
      });
    },
    downloadCommentSound(name,comment, index, showPlayer) {
      comment.audios[index].loading = true;
      axios({
        url: `complaint_comments/${comment.id}/audio/${name}`,
        method: "GET",
        responseType: "blob",
      }).then((res) => {

        comment.audios[index].loading = false;
        const href = URL.createObjectURL(res.data);

        if (!showPlayer) {
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.innerHTML = " download";
          link.setAttribute("download", name); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } else {
          comment.audios[index].urlObject = href;
        }
      }).finally(() => {
        this.filesLoader[index] = false;
      });
    },
    prepareFiles() {
      this.files = this.$refs.files.files;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: Poppins;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

@keyframes openScale {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.opacity-0 {
  opacity: 0 !important;
}

.open-scale {
  transform: scale(1) !important;
  opacity: 1 !important;
  animation: 0.2s openScale;
}

.open-fade {
  opacity: 1 !important;
  pointer-events: all !important;
}

.main-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(#222, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.4s;
  pointer-events: none;
  z-index: 12;
  backdrop-filter: blur(2px);

  .modal {
    
    padding: 25px 28px 36px;
    background: white;
    width: max-content;
    min-width: 850px;
    min-height: 550px;
    // max-width: 580px;
    height: fit-content;
    border-radius: 8px;
    margin-bottom: 4vh;
    position: absolute;
    top: 1rem;
    bottom: 1rem;
    transform: scale(0.8);
    opacity: 0;
    transition: 0.2s;

    .close-button {
      margin-inline-start:auto;
      margin-bottom: 1rem;
      background: rgba(#fff, 0.6);
      border: 1px solid #fff;
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      cursor: pointer;
      color: #84969e;

      span {
        margin-bottom: 1px;
        font-size: 1.5rem ;
      }
    }

    h2 {
      width: 100%;
      max-width: 100%;
      word-break: break-word;
      color: #202731;
      max-height: 400px;
      overflow-y: auto;
      font-size: 16pt;
      padding: 0;
      margin: 0;
      font-weight: 500;

      &::-webkit-scrollbar {
        width: 0.2em;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c1c5d8;
        border-radius: 9999px;
      }
    }

    p {
      margin-top: 8px;
      color: #84969e;
      font-size: 12pt;

      b {
        color: #202731 !important;
        font-weight: 500;
      }
    }

    .avatar-number {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 32px;
      padding: 2px;
      text-align: center;
      border-radius: 50%;
      background: #ccccff;
    }

    .inputs {
      width: 100%;
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .list {
      width: 100%;

      table {
        width: 100%;

        tr,
        td {
          padding: 2px;
        }

        td:last-child {
          text-align: right;
        }
      }
    }

    .input {
      width: 100%;
      margin-top: 6px;

      background: #f7f8fa;
      border: 1px solid #c1c5d8;
      border-radius: 8px;
      transition: 0.2s;

      &:focus {
        outline: none;
        border: 1px solid #ff9fa8;
        box-shadow: 0px 0px 2px #ff9fa8;
      }

      &[type=file] {
        width: 100%;
        padding: 2px;
        background: #f7f8fa;
        border: 1px solid #c1c5d8;
        border-radius: 8px;
        transition: 0.2s;
      }
    }

    .buttons-container {
      width: 100%;
      height: auto;
      margin-top: 22px;
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      button {
        padding: 10px 28px;
        width: auto;
        background: #e10015;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 400;
        cursor: pointer;
        transition: 0.1s;
        max-height: 43px;
        position: relative;

        &[outline] {
          background: #fff;
          border: 1px solid #e10015;
          color: #e10015;
        }

        &:hover {
          box-shadow: 0px 0px 6px rgba(#202731, 0.12);
        }
      }
    }
  }
}

/* Spinner */

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.textarea {
  width: 100%;
  outline-color: red !important;
  border-style: solid;
  border-color: grey;
  border-radius: 5px;
}

.spring-spinner {
  height: 100%;
  max-height: 18px;
  width: auto;
  max-width: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 9px;
  height: 100%;
  width: auto;
  max-width: 18px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 18px;
  height: 18px;
  border: 2.5px solid transparent;
  border-right-color: white;
  border-top-color: #d9d9d9;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

.status-dropdown {
  background: transparent;
  color: black;
  outline: none;
  width: max-content;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY4MzY3RTNGOUQyNDExRUM5QTY3RDdDOURGOTk4NEUxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY4MzY3RTQwOUQyNDExRUM5QTY3RDdDOURGOTk4NEUxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjgzNjdFM0Q5RDI0MTFFQzlBNjdEN0M5REY5OTg0RTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjgzNjdFM0U5RDI0MTFFQzlBNjdEN0M5REY5OTg0RTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5py8drAAAAo0lEQVR42mL8//8/AyWAiYFCMLgMWADEr4HYGY96RyB+BVULAaBAhOLP/yHgKxCbI4nDsAoQf4Cq+QQTR1aQ+R8BQAp1keREgfg2knwJNgNAuB5J0QuorWxAvBdJfAayHgYsTp2ApPgBEK9G4u+FGojXAEYgnv8fE9wCYn509dgMAGFmIF6HpPkV1DsMxBrAAHXqeiB+CcT2uNQxjuYFBoAAAwAJ+H5H38DlUQAAAABJRU5ErkJggg==");
  background-size: 14px;
  background-repeat: no-repeat;
  background-position: right;

  option {
    color: black;
    font-size: 14px;
  }
}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}
</style>
